import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles, Grid, Typography, CircularProgress } from '@material-ui/core';
import Highcharts from 'highcharts';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);

class DeviceUsage extends React.Component {
  getBatteryChart(battery) {
    const { t } = this.props;

    let series = [];
    if (battery && battery.length > 0) {
      battery.forEach((b) => {
        // set series
        series.push({
          type: 'area',
          name: b.deviceName,
          data: b.data,
          turboThreshold: null,
          color: b.color,
        });
      });
    }
    series.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

    const batteryChart = {
      chart: {
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        plotBorderWidth: 1,
        type: 'xrange',
        height: 250,
        spacingLeft: 85,
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'datetime',
        labels: {
          enabled: false,
        },
        visible: false,
      },
      yAxis: {
        title: {
          text: `${t('battery_level')} (%)`,
        },
        max: 100,
        min: 0,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        area: {
          // opacity: 90,
          marker: {
            radius: 2,
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1,
            },
          },
        },
      },
      series: series,
      tooltip: {
        headerFormat:
          '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {point.x:%H:%M:%S}</span><br/>',
        pointFormat: `{series.name} : {point.y}%`,
      },
    };

    return (
      <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
        <HighchartsReact highcharts={Highcharts} options={batteryChart} callback={this.props.dataChartBattery} />
      </Typography>
    );
  }

  getDeviceUsageChart(deviceData, uniqueNames) {
    const { t } = this.props;
    const dataAcvitity = {
      chart: {
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        plotBorderWidth: 1,
        type: 'xrange',
        height: `${uniqueNames.length * 30 + 35}px`,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        labels: {
          enabled: true,
        },
        visible: true,
      },
      yAxis: {
        title: {
          text: '',
        },
        categories: uniqueNames,
        reversed: true,
        labels: {
          useHTML: true,
          style: {
            minWidth: '120px',
            textAlign: 'right',
          },
        },
      },
      plotOptions: {
        series: {
          showInLegend: false,
        },
      },
      series: [
        {
          name: ' ',
          borderColor: 'gray',
          pointWidth: 20,
          data: deviceData,
          dataLabels: {
            enabled: true,
          },
          turboThreshold: 0,
        },
      ],
      tooltip: {
        headerFormat: '<span style="font-size: 10px"> {point.x:%H:%M:%S } - {point.x2:%H:%M:%S }</span><br/>',
        pointFormat: `<span style="color:{point.color}">● </span> <b>{point.yCategory}</b>`,
      },
    };

    if (deviceData.length > 0) {
      return (
        <Typography component='div' style={{ width: '100%' }}>
          <HighchartsReact highcharts={Highcharts} options={dataAcvitity} callback={this.props.dataChartDeviceUsage} />
        </Typography>
      );
    } else {
      return (
        <Grid item xs={12} sm={6} md={6}>
          <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
            {' '}
            {t('no_data')}
          </Typography>
        </Grid>
      );
    }
  }
  render() {
    let { t, classes } = this.props;
    const { checkingTodayData, hasDataToday, batteryData, deviceData, loadingDevice } =
      this.props.summary.toJS();

    return (
      <div className='w-screen bg-gradient-to-b from-primary-gradient to-transparent '>
        <Grid container>
          <div className='flex-wrap w-full pt-3 mx-auto px-19 md:flex'>
            {!checkingTodayData ? (
              !loadingDevice ? (
                <div className='w-full max-h-screen bg-white rounded md:box-content'>
                  <Grid container>
                    {hasDataToday && batteryData && batteryData.length > 0 ? (
                      <Typography component='div' style={{ width: '100%', paddingTop: '10px' }}>
                        {batteryData && batteryData.length > 0 && this.getBatteryChart(batteryData)}
                        {deviceData &&
                          deviceData.data &&
                          deviceData.data.length > 0 &&
                          this.getDeviceUsageChart(deviceData.data, deviceData.uniqueNames)}
                      </Typography>
                    ) : (
                      <Typography component='div' className={classes.noDataBox}>
                        {' '}
                        {t('no_data')}
                      </Typography>
                    )}
                  </Grid>
                </div>
              ) : (
                <div className='flex justify-center w-full text-center'>
                  <div className='flex mt-4'>
                    <CircularProgress size={26} />
                    <div className='px-5 pt-0.5  text-base text-gray-600'>{t('loading')}</div>
                  </div>
                </div>
              )
            ) : (
              ''
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  textLoading: {
    fontSize: '18px',
    textAlign: 'center',
    marginTop: '20px',
    padding: 8 * 3,
  },
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: '#6F7877',
  },
});
export const page = inject('summary')(observer(DeviceUsage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
